export class JobUserRoleEnum {
    readonly name: string;
    readonly id: number;

    private constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public static HiringTeamManager = new JobUserRoleEnum(
        10,
        "Hiring Team Manager"
    );
    public static JobManager = new JobUserRoleEnum(30, "Job Manager");
    public static AccountExecutive = new JobUserRoleEnum(
        40,
        "Account Executive"
    );
    public static Favorite = new JobUserRoleEnum(50, "Favorite");
    public static HiringTeamMember = new JobUserRoleEnum(
        60,
        "Hiring Team Member"
    );

    public static asArray = () => [
        JobUserRoleEnum.JobManager,
        JobUserRoleEnum.AccountExecutive,
        JobUserRoleEnum.HiringTeamManager,
        JobUserRoleEnum.HiringTeamMember,
        JobUserRoleEnum.Favorite,
    ];

    public static asArrayWithoutFavorite = () => [
        JobUserRoleEnum.JobManager,
        JobUserRoleEnum.AccountExecutive,
        JobUserRoleEnum.HiringTeamManager,
        JobUserRoleEnum.HiringTeamMember,
    ];

    public static fromId = (id: number) =>
        JobUserRoleEnum.asArray().find(t => t.id === id);

    public isIn = (arr: { jobSalaryTypeId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.jobSalaryTypeId === this.id) >= 0;
    };
}
